import React from "react";

export default function IconContinue({width, height}: any) {
  return (
    <svg
      width={width || "32"}
      height={height || "32"}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.8047 22C18.3275 22 22.8047 17.5228 22.8047 12C22.8047 6.47715 18.3275 2 12.8047 2C7.28184 2 2.80469 6.47715 2.80469 12C2.80469 17.5228 7.28184 22 12.8047 22Z"
        stroke="#14BC84"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.57422 12.2306V10.5606C9.57422 8.48061 11.0442 7.63061 12.8442 8.67061L14.2942 9.51061L15.7442 10.3506C17.5442 11.3906 17.5442 13.0906 15.7442 14.1306L14.2942 14.9706L12.8442 15.8106C11.0442 16.8506 9.57422 16.0006 9.57422 13.9206V12.2306Z"
        stroke="#14BC84"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
